import { useState, useEffect } from 'react';
import Drawer, { DrawerHeader } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { FormBody } from 'common/components/drawer';
import { FormFooter } from 'common/components/drawer';
import { Button, Row, Col } from 'reactstrap';

import Input from 'common/components/form/inputs/Input';
import { useForm, useFormState, useActions } from 'utils/hooks';
import * as classificationSocietyActions from 'store/classification-societies/actions';
import config from './config';

const ClassificationSocietyDrawer = ({ drawer, active }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateClassificationSociety] = useActions([
    classificationSocietyActions.updateClassificationSociety
  ]);
  const { formState, collectValues, loadValues, isDirty } = useForm(config, {});
  const { changeField, fields } = useFormState(formState);

  useEffect(() => {
    if (active) {
      loadValues(active);
    }
  }, [active, drawer.isOpen]);

  const handleSubmitForm = () => {
    setIsSubmitting(true);

    const formValues = collectValues();
    updateClassificationSociety({
      ...formValues,
      id: active.id,
      table: 'classification_societies'
    });

    setIsSubmitting(false);
    drawer.close();
  };

  return (
    <Drawer layout="table" {...drawer}>
      <DrawerHeader className="border-bottom pb-4">Edit Classification</DrawerHeader>
      <FormDrawer>
        <FormBody isDirty={isDirty}>
          <Row noGutters>
            <Col xs={12}>
              <Input label="Name" onChange={changeField('name')} {...fields.name} />
            </Col>
            <Col xs={12}>
              <Input
                label="Short Name"
                onChange={changeField('short_name')}
                {...fields.short_name}
              />
            </Col>
          </Row>
        </FormBody>

        <FormFooter>
          <Button color="cancel" className="px-0 py-1 me-4" onClick={() => drawer.close()}>
            CANCEL
          </Button>
          <Button
            onClick={handleSubmitForm}
            disabled={isSubmitting || !isDirty}
            color="primary"
            className="px-4"
          >
            SAVE
          </Button>
        </FormFooter>
      </FormDrawer>
    </Drawer>
  );
};

export default ClassificationSocietyDrawer;
